module.exports = __webpack_public_path__ + "img/freestyle_box01.f7a4be21.jpg";